import React from "react";
import ImageUploadFlow from "../ImageUploadFlow";

interface AssetGroupImageUploadModalProps {
  asset: { id?: string; name?: string; imageUrl?: string | null; __proposedGroup?: boolean; [key: string]: unknown };
  onClose?: (result?: { success: boolean; imageUrl?: string }) => void;
}


const AssetGroupImageUploadModal: React.FC<AssetGroupImageUploadModalProps> = ({
  asset,
  onClose,
}) => {
  const uploadTarget = asset?.__proposedGroup ? "generic" : "assetGroup";
  return (
    <ImageUploadFlow
      asset={asset}
      onClose={onClose}
      uploadTarget={uploadTarget}
    />
  );
};

export default AssetGroupImageUploadModal;
